"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPhoneSignupDto = instanceOfPhoneSignupDto;
exports.PhoneSignupDtoFromJSON = PhoneSignupDtoFromJSON;
exports.PhoneSignupDtoFromJSONTyped = PhoneSignupDtoFromJSONTyped;
exports.PhoneSignupDtoToJSON = PhoneSignupDtoToJSON;
exports.PhoneSignupDtoToJSONTyped = PhoneSignupDtoToJSONTyped;
/**
 * Check if a given object implements the PhoneSignupDto interface.
 */
function instanceOfPhoneSignupDto(value) {
    if (!('firebaseIdToken' in value) || value['firebaseIdToken'] === undefined)
        return false;
    if (!('countryId' in value) || value['countryId'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function PhoneSignupDtoFromJSON(json) {
    return PhoneSignupDtoFromJSONTyped(json, false);
}
function PhoneSignupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firebaseIdToken': json['firebaseIdToken'],
        'countryId': json['countryId'],
        'email': json['email'],
        'visitorId': json['visitorId'] == null ? undefined : json['visitorId'],
        'deviceFingerprint': json['deviceFingerprint'] == null ? undefined : json['deviceFingerprint'],
    };
}
function PhoneSignupDtoToJSON(json) {
    return PhoneSignupDtoToJSONTyped(json, false);
}
function PhoneSignupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'firebaseIdToken': value['firebaseIdToken'],
        'countryId': value['countryId'],
        'email': value['email'],
        'visitorId': value['visitorId'],
        'deviceFingerprint': value['deviceFingerprint'],
    };
}
